const algoliaKeys = {
  applicationId: 'S25465Z1JJ',
  searchOnlyApiKey: 'dad8e5ada0ac665997510f56b7118e87',
};

export default algoliaKeys;
